import React from 'react';

export default ({ className, width = '1em', height = '1em' }) => (
  <svg viewBox="0 0 44 43" width={width} height={height} className={className}>
    <g fill="currentColor" fillRule="nonzero">
      <path d="M13 42.3l-1.8-10.7H9.8l-3 6.9L4 31.6H2.6l-2 10.7h2.1l1.1-6.5 2.8 6.6h.6l2.9-6.6.9 6.5zM20.5 42.3v-1.8h-3.8v-2.8h3.6v-1.8h-3.6v-2.3h3.8v-1.8h-5.8v10.5h5.8zM32.1 42.3V31.8h-2v7.1l-6.2-7.1h-1.6v10.5h2v-7.1l6.2 7.1zM42.8 38.2v-6.4h-2.1v6c0 1.1 0 1.4-.3 1.9-.4.6-1.1 1-1.8 1s-1.5-.4-1.8-1c-.3-.5-.3-.8-.3-1.9v-6h-2v6.4c0 1.2.2 2.1.8 2.8.7.9 2 1.5 3.4 1.5s2.7-.6 3.5-1.5c.3-.7.6-1.6.6-2.8zM0 10h44v4H0zM0 0h44v4H0zM0 20h44v4H0z" />
    </g>
  </svg>
);
